import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useAuth } from "auth/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { loading, isAuthenticated, profile } = useAuth();
  const location = useLocation();

  // Only replace the route tree during the initial auth bootstrap. Once a
  // user is authenticated, background Supabase auth/token refreshes may
  // temporarily set loading=true; keeping children mounted preserves open
  // leads, table state, filters, and scroll position across tab changes.
  if (loading && !isAuthenticated) {
    return (
      <MDBox minHeight="100vh" display="flex" alignItems="center" justifyContent="center">
        <MDTypography variant="h6" color="text">Loading JCL Sales Intelligence…</MDTypography>
      </MDBox>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/authentication/sign-in" state={{ from: location }} replace />;
  }

  if (roles?.length && !roles.includes(profile?.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

ProtectedRoute.defaultProps = { roles: null };
ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string),
};
